import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.dark,
  },
}))

export default styles
